import { useState } from 'react';

import { useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useUserHook from 'hooks/useUserHook';

import { useMutationDeleteUser } from 'api/mutations/deleteUser.mutation';

import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import classes from 'components/Settings/Components/UsersManagement/components/usersManagement.module.scss';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { CustomizedConfirmDeleteModal, CustomizedRoundIcon } from 'components/common';

export const RowOptionsCell = ({ row }) => {
    const { email: currentUserEmail } = useUserHook();
    const { username, email } = row.original;
    const [show, setShow] = useState<boolean>(false);
    const history = useHistory();
    const mutation = useMutationDeleteUser();
    const { handleSnackBar } = useCustomSnackBar();
    const queryClient = useQueryClient();

    const handleEdit = () => {
        if (currentUserEmail === email) {
            history.push(AppRoutes.buildPath(AppRoutes.SETTINGS, settingsConfig.userProfile.link));
        } else {
            history.push(
                AppRoutes.buildPath(
                    AppRoutes.SETTINGS,
                    settingsConfig.userManagement.link,
                    settingsConfig.userManagementEditUser.link,
                    email,
                ),
            );
        }
    };

    const handleDelete = () => {
        mutation.mutate(
            { email: username },
            {
                onSuccess: () => {
                    handleSnackBar('User Successfully Deleted', 'success');
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => {
                    setShow(false);
                    return queryClient.invalidateQueries('usersList');
                },
            },
        );
    };

    return (
        <div data-testid={'actions'} className={classes.actions}>
            <CustomizedRoundIcon onClick={handleEdit}>
                <Icon data-testid={'edit-user'} name={'edit-user-profile'} />
            </CustomizedRoundIcon>

            <CustomizedRoundIcon onClick={() => setShow(true)}>
                <MuiIcon data-testid={'delete-user'} icon={'delete'} type={'outlined'} />
            </CustomizedRoundIcon>
            <CustomizedConfirmDeleteModal
                isShowModal={show}
                hideModal={() => setShow(false)}
                text={`Are you sure you want to delete user ${username}?`}
                onConfirm={handleDelete}
            />
        </div>
    );
};
